export default {
  namespaced: true,
  pagination: {
    title: "Paginación",
    page: "Página:",
    cancel: "Cancelar",
    page_not_found:"Pagina no encontrada",
    next_page: "Siguiente",
    prev_page: "Anterior",
  },
};
